import SpecDropdown from '../SpecDropdown/SpecDropdown';

interface IQuoteNewToolLaptopSpecs {
  processor?: string;
  hardDrive?: string;
  ram?: string;
  displayInches?: string;
  software?: string;
  inBoxAccessories?: string;
  onChangeSpec: (field: string, value: string) => void;
}

/**
 * Especificaciones técnicas para laptops/PC dentro del formulario de creación de SKU desde cotización.
 * Cada SpecDropdown carga sus propias opciones desde el backend via paramName.
 */
const QuoteNewToolLaptopSpecs = ({
  processor,
  hardDrive,
  ram,
  displayInches,
  software,
  inBoxAccessories,
  onChangeSpec
}: IQuoteNewToolLaptopSpecs) => {
  return (
    <div className="specsGrid laptopSpecs">
      <SpecDropdown
        label="Procesador"
        required
        paramName="procesador"
        placeholder="Seleccionar procesador"
        value={processor}
        onChange={value => onChangeSpec('processor', value)}
      />
      <SpecDropdown
        label="Almacenamiento"
        required
        paramName="almacenamiento"
        placeholder="Seleccionar almacenamiento"
        value={hardDrive}
        onChange={value => onChangeSpec('hardDrive', value)}
      />
      <SpecDropdown
        label="Memoria"
        required
        paramName="memoria"
        placeholder="Seleccionar memoria"
        value={ram}
        onChange={value => onChangeSpec('ram', value)}
      />
      <div className="specField">
        <label className="fieldLabel">Tamaño de la pantalla*</label>
        <input
          className="specInput"
          placeholder='14"'
          value={displayInches ?? ''}
          onChange={e => onChangeSpec('displayInches', e.target.value)}
        />
      </div>
      <SpecDropdown
        label="Sistema operativo"
        required
        paramName="software"
        placeholder="Seleccionar sistema operativo"
        value={software}
        onChange={value => onChangeSpec('software', value)}
      />
      <div className="specField">
        <label className="fieldLabel">Accesorios (opcional)</label>
        <input
          className="specInput"
          placeholder="Ej. Cargador"
          value={inBoxAccessories ?? ''}
          onChange={e => onChangeSpec('inBoxAccessories', e.target.value)}
        />
      </div>
    </div>
  );
};

export default QuoteNewToolLaptopSpecs;
